import React from 'react';
import styled, { css } from 'styled-components';

const StatusTag = styled.div`
  padding: 4px 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  margin-left: 10px;

  ${(props) => props.$isOnline ? css`
    color: #0f8f63;
    background-color: rgba(18, 165, 113, 0.1);
    border: 1px solid rgba(18, 165, 113, 0.2);
  ` : css`
    color: #7b8aa3;
    background-color: rgba(101, 116, 141, 0.07);
    border: 1px solid #e0e8f5;
  `}
`;

const Text = styled.span`
  display: block;
  font-size: 11px;
  font-weight: 400;
`;

const ImavenOnlineStatus = ({ isOnline }) => {
  return (
    <StatusTag 
      $isOnline={isOnline} 
      className={`status-badge-tag ${isOnline ? 'status-badge-online' : 'status-badge-offline'}`}
    >
      <Text>{isOnline ? 'Online' : 'Offline'}</Text>
    </StatusTag>
  );
};

export default ImavenOnlineStatus;